import React from 'react';
import { Box } from '@hz-design-system/web-ui';
import { ListingFigureRootProps, NoImageItemProps, SubImagesProps, MainImageItemProps } from './types';
import NoImageItem from './ListingFigureNoImage';
import SubImages from './ListingFigureSubImages';
import MainImageItem from './ListingFigureMainImage';
import Classes from './ListingListViewFigureRoot.module.scss';

const ListingFigure: React.FC<ListingFigureRootProps> & {
  NoImage: React.FC<NoImageItemProps>;
  SubImages: React.FC<SubImagesProps>;
  MainImage: React.FC<MainImageItemProps>;
} = ({ children }) => (
  <Box as="div" name="imageContainer" className={Classes['hz-Listing-image-container']}>
    {children}
  </Box>
);

ListingFigure.MainImage = MainImageItem;
ListingFigure.NoImage = NoImageItem;
ListingFigure.SubImages = SubImages;

export default ListingFigure;
